import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { useFacetMeta } from "../../hooks/useFacetMeta";
import { generateBreadcrumbSeoUrl } from "../../utils/seoUrlGenerator";

const hiddenPathnames = ["ls", "pd", "brands"];

const BreadcrumbCustom = () => {
  const location = useLocation();
  const { facetMappings, mappingsReady } = useFacetMeta();

  const originalPathSegments = location.pathname
    .split("/")
    .filter((path) => path.length > 0 && !hiddenPathnames.includes(path));

  const displayPathSegments = originalPathSegments.map((path) =>
    path.replace(/[-]/g, " "),
  );

  return (
    <Breadcrumb
      display={{ base: "block", lg: "none" }}
      mb={4}
      separator={<ChevronRightIcon color="gray.500" />}
    >
      <BreadcrumbItem>
        <BreadcrumbLink
          fontWeight={"500"}
          fontSize={{ base: "xs", "1xs": "sm" }}
          href="/"
        >
          Home
        </BreadcrumbLink>
      </BreadcrumbItem>

      {displayPathSegments.length > 0 &&
        displayPathSegments.map((path, index, arr) => {
          return index === arr.length - 1 ? (
            <BreadcrumbItem
              key={path}
              color={"grayC.200"}
              textTransform={"capitalize"}
            >
              <Text fontSize={{ base: "xs", "1xs": "sm" }}>
                {decodeURIComponent(path)}
              </Text>
            </BreadcrumbItem>
          ) : (
            <BreadcrumbItem key={path}>
              <BreadcrumbLink
                fontWeight={"500"}
                textTransform={"capitalize"}
                href={
                  mappingsReady && facetMappings
                    ? generateBreadcrumbSeoUrl(originalPathSegments.slice(0, index + 1), facetMappings)
                    : index === 0
                    ? `/${originalPathSegments[index]}`
                    : `/${originalPathSegments.slice(0, index + 1).join("/")}`
                }
                fontSize={{ base: "xs", "1xs": "sm" }}
              >
                {decodeURIComponent(path)}
              </BreadcrumbLink>
            </BreadcrumbItem>
          );
        })}
    </Breadcrumb>
  );
};

export default BreadcrumbCustom;
